import { atom } from 'nanostores'

type ActiveElement = HTMLElement | null

export const $lastActiveElement = atom<ActiveElement>(document.activeElement as ActiveElement)

export const saveLastActiveElement = (el?: ActiveElement) => {
  $lastActiveElement.set(el || (document.activeElement as ActiveElement))
}
